export default __webpack_public_path__ + "static/media/mbb-color.e752fcbe.svg";